export const StateTypes = {
  set: "STATE/SET",
  reset: "STATE/RESET",
  setCurrentSubscriber: "STATE/CURRENT_SUBSCRIBER/SET",
  setCurrentEdition:    "STATE/CURRENT_EDITION/SET",
  isSubscriber:         "STATE/IS_SUBSCRIBER/SET",
  isActiveSubscriber:   "STATE/IS_ACTIVE_SUBSCRIBER/SET"
};
